/** HSV to unit-scale sRGB (gamma-encoded). h in degrees [0,360), s/v in [0,1]. */
export function hsvToRgbUnit(c) {
    const h = ((c.h % 360) + 360) % 360;
    const s = c.s;
    const v = c.v;
    const C = v * s;
    const X = C * (1 - Math.abs(((h / 60) % 2) - 1));
    const m = v - C;
    let r = 0;
    let g = 0;
    let b = 0;
    if (h < 60) {
        r = C;
        g = X;
        b = 0;
    }
    else if (h < 120) {
        r = X;
        g = C;
        b = 0;
    }
    else if (h < 180) {
        r = 0;
        g = C;
        b = X;
    }
    else if (h < 240) {
        r = 0;
        g = X;
        b = C;
    }
    else if (h < 300) {
        r = X;
        g = 0;
        b = C;
    }
    else {
        r = C;
        g = 0;
        b = X;
    }
    return { r: r + m, g: g + m, b: b + m };
}
//# sourceMappingURL=hsv.js.map